<template>
    <div class="vx-card py-2">
        <vs-tabs v-model="activeTabExam">
            <vs-tab label="Phẫu thuật, thủ thuật">
                    <ParaclinicalExaminationStep :loyaltyCustomerId="loyaltyCustomerId" :type="activeTabExam" :statusOptions="statusOptions"></ParaclinicalExaminationStep>
            </vs-tab>
            <vs-tab label="Chẩn đoán hình ảnh">
                    <ParaclinicalExaminationStep :loyaltyCustomerId="loyaltyCustomerId" :type="activeTabExam" :statusOptions="statusOptions"></ParaclinicalExaminationStep>
            </vs-tab>
            <vs-tab label="Thăm dò chức năng">
                    <ParaclinicalExaminationStep :loyaltyCustomerId="loyaltyCustomerId" :type="activeTabExam" :statusOptions="statusOptions"></ParaclinicalExaminationStep>
            </vs-tab>
            <vs-tab label="Kết quả xét nghiệm">
                <TestResults :loyaltyCustomerId="loyaltyCustomerId"></TestResults>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import ParaclinicalExaminationStep from "./ParaclinicalExaminationStep";
import TestResults from "./TestResults";

export default {
    name: "SubclinicalStep",
    components: {
        ParaclinicalExaminationStep,
        TestResults
    },
    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
    },
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },
            activeTabExam: 0,
            parentId: null,
            statusOptions: [],
        }
    },
    created() {
        this.getParentId();
    },

    methods: {
        getParentId() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/setting-medical-examination-step/find-by-condition', {isGetParent: true}).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.parentId = res.data.content[3].medicalExaminationStep.id;
                        this.statusOptions = res.data.content[3].listChildren.map(el => {
                            return {
                                value: el.id,
                                label: el.medicalExaminationStep.name,
                            }
                        })
                        this.statusOptions.unshift({value: 'null', label: 'Tất cả'})
                    }
                    this.$vs.loading.close();
                    resolve(res)
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    }
}
</script>

<style scoped>

</style>
